import { Injectable } from "@angular/core";
import { AppStateDbDao } from "../../gyzmo-commons/dao/db/appState.db.dao";
import { CacheDbDao } from "../../gyzmo-commons/dao/db/cache.db.dao";
import { IdWordingDbDao } from "../../gyzmo-commons/dao/db/idWording.db.dao";
import { KeyValueDbDao } from "../../gyzmo-commons/dao/db/keyValue.db.dao";
import { VersionDbDao } from "../../gyzmo-commons/dao/db/version.db.dao";
import { AddressDbDao } from "../dao/db/address.db.dao";
import { AttachmentDbDao } from "../dao/db/attachment.db.dao";
import { CompanyDbDao } from "../dao/db/company.db.dao";
import { ContactDetailsDbDao } from "../dao/db/contactDetails.db.dao";
import { DriverInfoDbDao } from "../dao/db/driverInfo.db.dao";
import { EquipmentDbDao } from "../dao/db/equipment.db.dao";
import { FtRecordDbDao } from "../dao/db/ftRecord.db.dao";
import { DamageCategoryDbDao } from "../dao/db/inspection/common/damageCategory.db.dao";
import { DamageValuesDbDao } from "../dao/db/inspection/common/damageValues.db.dao";
import { GroupCategoryDbDao } from "../dao/db/inspection/common/groupCategory.db.dao";
import { ChecklistDbDaoV2 } from "../dao/db/inspection/v2/checklist.db.dao";
import { ChecklistElementDbDaoV2 } from "../dao/db/inspection/v2/checklistElement.db.dao";
import { DamageDbDaoV2 } from "../dao/db/inspection/v2/damage.db.dao";
import { FaceDbDaoV2 } from "../dao/db/inspection/v2/face.db.dao";
import { InspectionDbDaoV2 } from "../dao/db/inspection/v2/inspection.db.dao";
import { ZoneDbDaoV2 } from "../dao/db/inspection/v2/zone.db.dao";
import { ZoneElementDbDaoV2 } from "../dao/db/inspection/v2/zoneElement.db.dao";
import { LocationDbDao } from "../dao/db/location.db.dao";
import { MaintenanceControlsDbDao } from "../dao/db/maintenanceControls.db.dao";
import { MovementDbDao } from "../dao/db/movement.db.dao";
import { OfflineModeDbDao } from "../dao/db/offlineMode.db.dao";
import { RegistrationDbDao } from "../dao/db/registration.db.dao";
import { ServerDbDao } from "../dao/db/server.db.dao";
import { ThirdPartyDbDao } from "../dao/db/thirdParty.db.dao";
import { UserDbDao } from "../dao/db/user.db.dao";

@Injectable({
    providedIn: "root",
})
export class DaoProvider {
    constructor(private appStateDbDao: AppStateDbDao,
                private attachmentDbDao: AttachmentDbDao,
                private cacheDbDao: CacheDbDao,
                private checklistDbDaoV2: ChecklistDbDaoV2,
                private checklistElementDbDaoV2: ChecklistElementDbDaoV2,
                private companyDbDao: CompanyDbDao,
                private contactDetailsDbDao: ContactDetailsDbDao,
                private damageCategoryDbDao: DamageCategoryDbDao,
                private damageDbDaoV2: DamageDbDaoV2,
                private damageValuesDbDao: DamageValuesDbDao,
                private driverInfoDbDao: DriverInfoDbDao,
                private equipmentDbDao: EquipmentDbDao,
                private faceDbDaoV2: FaceDbDaoV2,
                private groupCategoryDbDao: GroupCategoryDbDao,
                private inspectionDbDaoV2: InspectionDbDaoV2,
                private keyValueDbDao: KeyValueDbDao,
                private idWordingDbDao: IdWordingDbDao,
                private locationDbDao: LocationDbDao,
                private maintenanceControlsDbDao: MaintenanceControlsDbDao,
                private movementDbDao: MovementDbDao,
                private offlineModeDbDao: OfflineModeDbDao,
                private recordDbDao: FtRecordDbDao,
                private registrationDbDao: RegistrationDbDao,
                private serverDbDao: ServerDbDao,
                private thirdPartyDbDao: ThirdPartyDbDao,
                private userDbDao: UserDbDao,
                private versionDbDao: VersionDbDao,
                private zoneDbDaoV2: ZoneDbDaoV2,
                private zoneElementDbDaoV2: ZoneElementDbDaoV2,
                private addressDbDao: AddressDbDao) {
    }

    public getAllDaoList() {
        return [
            this.addressDbDao,
            this.appStateDbDao,
            this.attachmentDbDao,
            this.cacheDbDao,
            this.checklistDbDaoV2,
            this.checklistElementDbDaoV2,
            this.companyDbDao,
            this.contactDetailsDbDao,
            this.damageCategoryDbDao,
            this.damageDbDaoV2,
            this.damageValuesDbDao,
            this.driverInfoDbDao,
            this.equipmentDbDao,
            this.faceDbDaoV2,
            this.groupCategoryDbDao,
            this.inspectionDbDaoV2,
            this.idWordingDbDao,
            this.locationDbDao,
            this.maintenanceControlsDbDao,
            this.movementDbDao,
            this.offlineModeDbDao,
            this.recordDbDao,
            this.registrationDbDao,
            this.serverDbDao,
            this.thirdPartyDbDao,
            this.userDbDao,
            this.versionDbDao,
            this.zoneDbDaoV2,
            this.zoneElementDbDaoV2,
            this.keyValueDbDao,
        ];
    }

    public getOnDisconnectDaoList() {
        return [
            this.addressDbDao,
            this.attachmentDbDao,
            this.checklistDbDaoV2,
            this.checklistElementDbDaoV2,
            this.companyDbDao,
            this.contactDetailsDbDao,
            this.damageCategoryDbDao,
            this.damageDbDaoV2,
            this.damageValuesDbDao,
            this.driverInfoDbDao,
            this.equipmentDbDao,
            this.faceDbDaoV2,
            this.groupCategoryDbDao,
            this.inspectionDbDaoV2,
            this.idWordingDbDao,
            this.locationDbDao,
            this.maintenanceControlsDbDao,
            this.movementDbDao,
            this.offlineModeDbDao,
            this.recordDbDao,
            this.registrationDbDao,
            this.thirdPartyDbDao,
            this.userDbDao,
            this.zoneDbDaoV2,
            this.zoneElementDbDaoV2,
        ];
    }
}
